<template>
  <v-card
    flat
    class="ml-4 d-flex flex-column align-center justify-center rounded-20"
    height="100%"
  >
    <v-card-title>
      <div class="mx-auto">
        <div class="text-center mb-2">
          <v-progress-circular indeterminate size="64" v-if="loading" />
          <v-icon
            size="64"
            color="success"
            v-if="associationPass && !collisions.length && !loading"
          >
            mdi-check-circle
          </v-icon>
          <v-icon
            size="64"
            color="warning"
            v-if="(!associationPass || collisions.length) && !loading"
          >
            mdi-alert-circle-outline
          </v-icon>
        </div>
        <div>
          Scan Gauge Association
          <span v-if="associationPass && !loading"> Completed </span>
          <span v-if="!associationPass && !loading">
            Warning{{ !associationPass && collisions.length ? "s" : null }}
          </span>
        </div>
      </div>
    </v-card-title>
    <v-card-text
      v-if="(!associationPass || collisions.length) && !loading"
      class="text-center"
    >
      <template v-if="!associationPass">
        <h3 class="black--text mb-4">Alignment Warning</h3>
        <p>
          Please manually check the gauges highlighted in orange to ensure that
          the scan bodies are positioned correctly. This is a warning only.
          <br />
          <strong>The case may continue at the labs discretion.</strong>
        </p>
      </template>
      <template v-if="collisions.length">
        <h3 class="black--text mb-4">Proximity Warning</h3>
        <p>
          If Scan Gauges are touching, one may not be seated, this can create
          inaccurate scan exports. This is a warning only, and may not be true
          to the actual scan data.
          <br />
          <strong>The case may continue at the labs discretion.</strong>
        </p>
        <p class="font-italic">
          Proximity cannot be determined at the analyzer phase, only when the
          library is associated.
        </p>
        <p>
          If you believe the error is due to a mis-selected Scan Gauge during
          library association, click 'Redo Association'. If not, new scans will
          be needed, OR, continue with the case as is.
        </p>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-btn
        small
        text
        class="btn-primary mx-auto"
        @click="$emit('redo')"
        :disabled="selectedOrderExports?.length > 0"
      >
        <v-icon class="mr-2">mdi-restore</v-icon>
        Redo Association
      </v-btn>
      <v-btn
        small
        text
        class="btn-primary ml-3"
        :to="{ query: { tab: 'export' } }"
      >
        <v-icon class="mr-2">mdi-download</v-icon>
        Download Export
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "AssociationResult",

  props: ["associationPass", "collisions", "loading"],

  computed: {
    ...mapGetters(["selectedOrder", "selectedOrderExports"])
  }
}
</script>
